import { ApiResponseBody } from '@/setup/api'

type CityRestaurantsResponse = ApiResponseBody<
    'get',
    '/web/restaurants/cities/{citySlug}/restaurants'
>

export type GetCityRestaurantResponseData = CityRestaurantsResponse['data']
export type GetCityRestaurantResponseMeta = CityRestaurantsResponse['meta']

export type IDetailRestaurant = ApiResponseBody<'get', '/web/restaurants/{restaurantSlug}'>['data']

export type IListRestaurant = GetCityRestaurantResponseData[number]

export type ITag = NonNullable<IDetailRestaurant['tags']>[number]

export type IRestaurantDeal = NonNullable<IDetailRestaurant['deals']>[number]
export type IRestaurantReward = NonNullable<IDetailRestaurant['loyalty']>['rewards'][number]

export type Day = NonNullable<IDetailRestaurant['openingHours']>[number]['day']

export const Days: Day[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
]

export interface IOpeningHour {
    uuid: string
    day: Day
    openingTime: string
    closingTime: string
}

export interface IMenuGroup {
    uuid: string
    name: string
    menuItems: IMenuItem[] | undefined
}

export interface IMenuItem {
    uuid: string
    name: string
    description: string | null
    price: number | null
}
